import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap'
import { FaEdit, FaUser } from 'react-icons/fa';
import { Form, InputPicker, SelectPicker } from 'rsuite';
import Swal from 'sweetalert2';
import credentialService from '../../../../services/Internal/Credential/credential.service';
import { emailPhonePrivacy, journalDropdown, subscribeDropdown } from '../../../../services/Shared/codeTable.service';
import LoadingSpinner from '../../../Shared/GenericComponents/LoadingSpinner';
import PhoneNumberMask from '../../../Shared/GenericComponents/PhoneNumberMask';
import TextArea from '../../../Shared/GenericComponents/TextArea';
import EditIndGeneralInformation from './EditIndGeneralInformationModal';

function GeneralInfoCard(props) {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState({});
    const [genInfoFormData, setGenInfoFormData] = useState({});

    useEffect(() => {
        updateCard();
    }, [])

    const updateCard = () => {
        setHasLoaded(false);
        credentialService.getIndGeneralInfo(props.entityId).then((response) => {
            setData(response.data);
            setGenInfoFormData({
                userId: response.data.userName ?? '',
                dateOfBirth: response.data.dateOfBirth ? new Date(response.data.dateOfBirth).toLocaleDateString() : '',
                dateOfDeath: response.data.dateOfDeath ? new Date(response.data.dateOfDeath).toLocaleDateString() : '',
                birthCity: response.data.birthCity ?? '',
                birthState: response.data.birthState?.state ?? '',
                nonUsBirthState: response.data.nonUsBirthState ?? '',
                birthCountry: response.data.birthCountry?.country ?? '',
                federalId: response.data.federalId ?? '',
                visaGreenCardNumber: response.data.visaGreenCardNumber ?? '',
                myNceesNumber: response.data.myNceesNumber ?? '',
                isUsCitizen: response.data.isUsCitizen ? "Yes" : "No",
                email: response.data.primaryEmailAddress?.contactEmailAddress ?? '',
                alternateEmail: response.data.alternateEmailAddress?.contactEmailAddress ?? '',
                homePhone: response.data.homePhone?.contactPhoneNumber ?? '',
                mobilePhone: response.data.cellPhone?.contactPhoneNumber ?? '',
                workPhone: response.data.workPhone?.contactPhoneNumber ?? '',
                amountDue: response.data.amountDue.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                }),
                additionalInformation: response.data.additionalInformation ?? '',
                citizenshipCountry: response.data.citizenshipCountry?.country ?? '',
                certificateName: response.data.certificateName ?? '',
                journalSubscription: response.data.journalSubscription,
                pressReleases: response.data.pressReleases,
                webinar: response.data.webinar,
                emailPhonePrivacy: response.data.emailPhonePrivacy,

            })
            setHasLoaded(true);
        })
    }
    const saveGenInfo = () => {
        updateCard();
        Swal.fire('Success!', "You have successfully updated this individual's general information.", 'success');
    }
    const setAddress = (address) => {
        if (address?.streetAddress) {
            var addresses = address.streetAddress.split("\n").filter(x => (x != "") && (x != "\r"));
            return (
                addresses.map((addressComponents) => {
                    return (<><span>{addressComponents}</span><br /></>);
                })
            );
        }
    }
    return <>
        <EditIndGeneralInformation saveDataCallback={saveGenInfo} show={showModal} onHide={() => setShowModal(false)} entityid={props.entityId} />
        <Card className="w-100">
            <Card.Header className="text-center" style={{ background: 'white' }}>
                <a href={"internal/contactChangeLog?entityId=" + props.entityId} target="_blank" className="changeLog">
                    <span className="fakeH6">GENERAL</span>
                    <br/>
                    <FaUser fontSize='42' />
                    </a>
            </Card.Header>
            <Card.Body>{
                hasLoaded ?
                    <>
                        <div className="text-center mb-3">
                            <h4>{data.formattedName}</h4>
                            <span>LOLA #</span><br />
                            <span>{data.lolaNumber}</span>
                            <hr />
                            <h6>Address Information</h6>
                        </div>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header>Mailing Address</Card.Header>
                                    <Card.Body>
                                        {data.mailingAddress && <>
                                            {setAddress(data.mailingAddress)}
                                            {data.mailingAddress?.country?.country == 'United States' ?
                                                <span>{data.mailingAddress?.city}, {data.mailingAddress?.state?.code} {data.mailingAddress?.postalCode} </span> :
                                                <span>{data.mailingAddress?.city}, {data.mailingAddress?.provinceRegion} {data.mailingAddress?.postalCode} </span>}
                                            <br />
                                            <span>{data.mailingAddress?.country?.country} </span><br />
                                        </>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card>
                                    <Card.Header>Public Address</Card.Header>
                                    <Card.Body>
                                        {data.publicAddress &&
                                            <>
                                                {setAddress(data.publicAddress)}
                                                {data.publicAddress?.country?.country == 'United States' ?
                                                    <span>{data.publicAddress?.city}, {data.publicAddress?.state?.code} {data.publicAddress?.postalCode} </span> :
                                                    <span>{data.publicAddress?.city}, {data.publicAddress?.provinceRegion} {data.publicAddress?.postalCode} </span>}
                                                <br />
                                                <span>{data.publicAddress?.country?.country} </span><br />
                                            </>}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <hr />
                        <Form fluid formValue={genInfoFormData}>
                            <Row className="mb-3">
                                <Col>
                                    <Form.ControlLabel><b>UserId</b></Form.ControlLabel>
                                    <Form.Control name="userId" disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Date of Birth</b></Form.ControlLabel>
                                    <Form.Control name="dateOfBirth" disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Date of Death</b></Form.ControlLabel>
                                    <Form.Control name="dateOfDeath" disabled />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.ControlLabel><b>City of Birth</b></Form.ControlLabel>
                                    <Form.Control name="birthCity" disabled />
                                </Col>
                                <Col>
                                    {genInfoFormData.birthCountry == "United States" &&
                                        <>
                                            <Form.ControlLabel><b>State of Birth</b></Form.ControlLabel>
                                            <Form.Control name="birthState" disabled />
                                        </>
                                    }
                                    {genInfoFormData.birthCountry != "United States" &&
                                        <>
                                            <Form.ControlLabel><b>State/Province/Region</b></Form.ControlLabel>
                                            <Form.Control name="nonUsBirthState" disabled />
                                        </>
                                    }
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Country of Birth</b></Form.ControlLabel>
                                    <Form.Control name="birthCountry" disabled />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.ControlLabel><b>SSN/FEIN</b></Form.ControlLabel>
                                    <Form.Control name="federalId" disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Visa/Green Card No.</b></Form.ControlLabel>
                                    <Form.Control name="visaGreenCardNumber" disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>NCEES ID #</b></Form.ControlLabel>
                                    <Form.Control name="myNceesNumber" disabled />
                                </
                                Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.ControlLabel><b>Email/Phone Privacy</b></Form.ControlLabel>
                                    <Form.Control
                                        name="emailPhonePrivacy"
                                        data={emailPhonePrivacy}
                                        accepter={InputPicker}
                                        block
                                        disabled />

                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Email</b></Form.ControlLabel>
                                    {genInfoFormData.email ? <div className="rs-form-control-wrapper"><a href={"mailto:" + genInfoFormData.email + ""}>{genInfoFormData.email}</a></div> : <Form.Control name="email" disabled />}
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Alternate Email</b></Form.ControlLabel>
                                    {genInfoFormData.alternateEmail ? <div className="rs-form-control-wrapper"><a href={"mailto:" + genInfoFormData.alternateEmail + ""}>{genInfoFormData.alternateEmail}</a></div> : <Form.Control name="alternateEmail" disabled />}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.ControlLabel><b>Mobile Phone</b></Form.ControlLabel>
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        format="(###) ###-####"
                                        name="mobilePhone"
                                        disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Work Phone</b></Form.ControlLabel>
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        format="(###) ###-####"
                                        name="workPhone"
                                        disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Home Phone</b></Form.ControlLabel>
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        format="(###) ###-####"
                                        name="homePhone"
                                        disabled />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.ControlLabel><b>US Citizen</b></Form.ControlLabel>
                                    <Form.Control name="isUsCitizen" disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Certificate Name</b></Form.ControlLabel>
                                    <Form.Control name="certificateName" disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Amount Due</b></Form.ControlLabel>
                                    <Form.Control name="amountDue" disabled />
                                </Col>
                            </Row>
                            {
                                data.isUsCitizen == false &&
                                <Row className="mb-3">
                                    <Col>
                                        <>
                                            <Form.ControlLabel><b>Citizenship Country</b></Form.ControlLabel>
                                            <Form.Control name="citizenshipCountry" disabled />
                                        </>
                                    </Col>
                                    <Col></Col>
                                    <Col></Col>
                                </Row>
                            }
                            <Row className='mb-3'>
                                <Col>
                                    <Form.ControlLabel><b>Additional Information</b></Form.ControlLabel>
                                    <Form.Control rows={3} accepter={TextArea} name="additionalInformation" disabled /></Col>

                            </Row>
                            <hr />
                            <Row className='mb-3'>
                                <Col>
                                    <Form.ControlLabel><b>Journal</b></Form.ControlLabel>
                                    <Form.Control
                                        name="journalSubscription"
                                        data={journalDropdown}
                                        accepter={SelectPicker}
                                        searchable={false}
                                        block
                                        disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Press Releases</b></Form.ControlLabel>
                                    <Form.Control
                                        name="pressReleases"
                                        data={subscribeDropdown}
                                        accepter={SelectPicker}
                                        searchable={false}
                                        block
                                        disabled />
                                </Col>
                                <Col>
                                    <Form.ControlLabel><b>Webinar</b></Form.ControlLabel>
                                    <Form.Control
                                        name="webinar"
                                        data={subscribeDropdown}
                                        accepter={SelectPicker}
                                        searchable={false}
                                        block
                                        disabled />
                                </Col>
                            </Row>
                        </Form>
                    </> : <LoadingSpinner />
            }
            </Card.Body>
            <Card.Footer className='text-end'>
                <Button variant='light' onClick={() => setShowModal(true)}><FaEdit /></Button>
            </Card.Footer>
        </Card >
    </>;
}


export default GeneralInfoCard;